import gql from 'graphql-tag';

const query = gql`
  query LaboratoryTests {
    diabetes {
      totalCholesterol: lipidProfileTestHistory(lipidProfileType: TOTAL_CHOLESTEROL) {
        edges {
          node {
            id
            totalCholesterol
            testedAt
            unit
          }
        }
      }
      ldl: lipidProfileTestHistory(lipidProfileType: LDL) {
        edges {
          node {
            id
            ldl
            testedAt
            unit
          }
        }
      }
      hdl: lipidProfileTestHistory(lipidProfileType: HDL) {
        edges {
          node {
            id
            hdl
            testedAt
            unit
          }
        }
      }
      triglycerides: lipidProfileTestHistory(lipidProfileType: TRIGLYCERIDES) {
        edges {
          node {
            id
            triglycerides
            testedAt
            unit
          }
        }
      }
      hba1c: HbA1cTestHistory {
        edges {
          node {
            id
            value
            testTime
            levels
          }
        }
      }
    }
  }
`;

export default query;
